










import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Base64 } from 'js-base64';

import { PoiPanorama } from '@/models/poi';
import { urlize } from '@/utils';

@Component
export default class PoiSlidePanorama extends Vue {

    @Prop(Object) public model: PoiPanorama;
    @Prop({ type: Boolean, default: true }) public enabled: boolean;

    get panoramaUrl() {
        return urlize(this.model.panorama.default);
    }

    get imageUrl() {
        return urlize(this.model.preview.medium);
    }

    public onPlayClicked() {
        if (!this.enabled) return;

        const panoramaUrlEncoded = Base64.encode(this.panoramaUrl);
        this.$f7router.navigate(`/panoplayer/${panoramaUrlEncoded}/`);

        this.$ga.event({
            eventCategory: 'poi',
            eventAction: 'playPanorama',
            eventLabel: this.panoramaUrl,
        });
    }
}
